module.exports = __webpack_public_path__ + "static/media/0.237553db.png";